import { createFileRoute } from '@tanstack/react-router'

import { KnowledgeSettingsPage } from '#features/settings/knowledge/knowledge-settings-page'

export const Route = createFileRoute('/_app/$workspace/settings/knowledge')({
  head: () => ({
    meta: [
      {
        title: 'Knowledge settings',
      },
    ],
  }),
  component: () => <KnowledgeSettingsPage />,
})
